import { useCallback, useEffect, useState } from "react";

const HINT_EVENT = "carry:hint-dismissed";

function readFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function useHintDismissed(key: string): [boolean, () => void] {
  const [dismissed, setDismissed] = useState<boolean>(() => readFlag(key));

  useEffect(() => {
    function handler(e: Event) {
      const detail = (e as CustomEvent<{ key: string }>).detail;
      if (!detail || detail.key === key) {
        setDismissed(readFlag(key));
      }
    }
    window.addEventListener(HINT_EVENT, handler);
    return () => window.removeEventListener(HINT_EVENT, handler);
  }, [key]);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(key, "1");
    } catch {
      // non-fatal
    }
    setDismissed(true);
    try {
      window.dispatchEvent(new CustomEvent(HINT_EVENT, { detail: { key } }));
    } catch {
      // non-fatal
    }
  }, [key]);

  return [dismissed, dismiss];
}

export const HINT_KEYS = {
  opportunitiesManageAlerts: "carry:hint:opportunities-manage-alerts:dismissed",
  communitiesManageAlerts: "carry:hint:communities-manage-alerts:dismissed",
} as const;
